import axios from "@/axios";

export const namespaced = true


export const state = { }

export const getters = { }

export const mutations = { }

export const actions = {
    async deleteSignature({ commit }, obj) {
        try {
            return await axios.post('api/ordertransactions/signatures/delete', obj)
        }
        catch (error) {
            //console.log("ERROR: ", error);
            // Re-throw to allow component to handle flow (close modal, reload data)
            throw error;
        }
    },
    clearData({ commit }) {
        commit("CLEAR_DATA");
    },
}
